const drawerSelector = '#nd-drawer';
const drawerButtonSelector = '.nd-drawer-button';
const openClass = '--open';

export function initDrawer() {
  const drawer = document.querySelector(drawerSelector);

  if (!drawer) {
    return;
  }

  const drawerButton = document.querySelector(drawerButtonSelector);

  const setDrawerState = (isOpen) => {
    drawer.classList.toggle(openClass, isOpen);
    drawer.setAttribute('aria-hidden', String(!isOpen));

    if (drawerButton) {
      drawerButton.setAttribute('aria-expanded', String(isOpen));
      drawerButton.setAttribute('aria-label', isOpen ? 'メニューを閉じる' : 'メニューを開く');
    }
  };

  setDrawerState(drawer.classList.contains(openClass));

  drawerButton?.addEventListener('click', () => {
    setDrawerState(!drawer.classList.contains(openClass));
  });
}
